export type AirwallexCardIframeKind = 'details' | 'pin' | 'change-pin';

export type AirwallexCardIframeSession = {
  token: string;
  cardId: string;
  iframeOrigin: string;
  langKey?: string;
  rules?: Record<string, Record<string, string>>;
};

const PATH_BY_KIND: Record<AirwallexCardIframeKind, string> = {
  details: 'details',
  pin: 'pin',
  'change-pin': 'change-pin',
};

export function defaultAirwallexIframeOrigin(): string {
  return 'https://airwallex.com';
}

export function buildAirwallexCardIframeSrc(
  session: AirwallexCardIframeSession,
  kind: AirwallexCardIframeKind,
): string {
  const hash = encodeURIComponent(
    JSON.stringify({
      token: session.token,
      langKey: session.langKey ?? 'en',
      ...(session.rules ? { rules: session.rules } : {}),
    }),
  );
  const origin = session.iframeOrigin || defaultAirwallexIframeOrigin();
  return `${origin.replace(/\/$/, '')}/issuing/pci/v2/${session.cardId}/${PATH_BY_KIND[kind]}#${hash}`;
}

export function isAirwallexIframeMessageOrigin(origin: string): boolean {
  return origin.includes('airwallex.com');
}

export function parseAirwallexIframeEvent(
  cardId: string,
  kind: AirwallexCardIframeKind,
  data: unknown,
): { type: string; height?: number; error?: string } | null {
  if (!data || typeof data !== 'object' || !('type' in data)) {
    return null;
  }
  const type = String((data as { type?: string }).type ?? '');
  const prefix =
    kind === 'change-pin' ? `${cardId}:changePin:` : `${cardId}:${kind === 'details' ? 'details' : 'pin'}:`;
  if (!type.startsWith(prefix)) {
    return null;
  }
  const payload = data as { height?: number; error?: string; errorCode?: string };
  return {
    type: type.slice(prefix.length),
    height: typeof payload.height === 'number' ? payload.height : undefined,
    error: payload.error ?? payload.errorCode,
  };
}
